import axiosClient from "api/axios_client.js";

const apiCampaign = {
  create: (payload) => axiosClient.post("/email-management/campaigns/create", payload),
  getAll: (payload) => axiosClient.post("/email-management/campaigns/get-all", payload),
  getAllData: () => axiosClient.get("/email-management/campaigns/get-all"),
  getById: (id) => axiosClient.get(`/email-management/campaigns/get-by-id/${id}`),
  getReport: (id, params) => axiosClient.get(`/email-management/campaigns/report/${id}`, { params }),
  dashboardStats: () => axiosClient.get("/email-management/campaigns/dashboard-stats"),
  resolveAudience: (payload) => axiosClient.post("/email-management/campaigns/resolve-audience", payload),
  cancel: (id) => axiosClient.post("/email-management/campaigns/cancel", { id }),
  delete: (id) => axiosClient.delete("/email-management/campaigns/delete", { data: { id } }),
};

export default apiCampaign;
